import { defineStore } from "pinia";
import { ref } from "vue";

export const useRPCStore = defineStore("rpc", () => {
	// data
	const rpcURL = ref<string>("https://nyc.shield.fogo.testnet.fluxrpc.com?key=B5uP49XccWKb_BXHc4_u9A");

	return { rpcURL };
});
